import React from 'react'
import * as Sentry from '@sentry/react'
import ErrorPage from '../pages/ErrorPages/ErrorPage';
import { sendUIErrorRequest } from '../utils/apiRequests';

type MyState = {
  hasError: boolean
}

type MyProps = {
  children?: React.ReactNode
}

class ErrorBoundary extends React.Component<MyProps, MyState> {
  constructor(props: MyProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    if (process.env.REACT_APP_NODE_ENV !== 'production') {
      return
    }

    // Report to Sentry
    Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: errorInfo.componentStack,
        },
      },
      extra: {
        errorInfo,
      },
    });

    // Skip reporting in development

    // Also send to your existing error reporting endpoint
    sendUIErrorRequest(errorInfo.componentStack).catch((_) => {
      // do nothing
    })
  }

  render() {
    const reloadPage = <a href="/">Please Reload Page!</a>
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorPage code="500" action={reloadPage} />
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary
